import React from 'react';
import { contactLinks } from '../data';

const Contact = () => {
  return (
    <section className="px-4 py-20">
      <div className="mx-auto max-w-5xl text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.4em] text-slate-400">Contact</p>
        <h2 className="mt-3 text-4xl font-bold text-white">Let’s collaborate on something meaningful.</h2>
        <p className="mt-4 text-base text-slate-300">
          Open to internships, research collaborations, mentorship opportunities, and any project where creativity meets software.
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-4">
          {contactLinks.map((link) => (
            <a
              key={link.label}
              className="inline-flex items-center gap-2 rounded-full border border-white/20 px-6 py-3 text-sm font-semibold text-white transition hover:border-brand"
              href={link.href}
              target={link.href.startsWith('http') ? '_blank' : undefined}
              rel={link.href.startsWith('http') ? 'noreferrer' : undefined}
            >
              <link.icon size={18} />
              {link.label}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Contact;
